/* Svensk katalog for locale-autopilot-customers.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('sv', {
  'ap.customerFollowup.title': 'Kunduppföljning',
  'ap.customerFollowup.waiting': 'Väntar på svar',
  'ap.customerFollowup.ready': 'Redo för offert',
  'ap.customerFollowup.document': 'Offert eller order att följa upp',
  'ap.customerFollowup.openChat': 'Öppna chatt',
  'ap.customerFollowup.empty': 'Inga kunder behöver följas upp just nu.',
});
